import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import {
  isAbleToSeeUIElement,
  ToolsRoles,
} from '../../../utils/roles/client-roles';
import { Dispatch, SetStateAction } from 'react';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import { useNavigate } from 'react-router-dom';
import { pagesConfig } from '../../../shared/pages-config';
import { Messages } from '../../../utils/message-constants';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';

interface ReportsGridToolbarProps {
  toolsRoles: string[];
  setOpenDeleteDialog: Dispatch<SetStateAction<boolean>>;
  selectedRows: number[];
}

export default function ReportsGridToolbar({
  toolsRoles,
  setOpenDeleteDialog,
  selectedRows,
}: ReportsGridToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          variant="contained"
          onClick={() => {
            navigate(
              `/${pagesConfig.reports.link}/${pagesConfig.createReport.link}`
            );
          }}
          disabled={
            !isAbleToSeeUIElement(toolsRoles, ToolsRoles.CreateReport.value)
          }
          label="Create Report"
          tooltipLabel={
            !isAbleToSeeUIElement(toolsRoles, ToolsRoles.CreateReport.value)
              ? Messages.Errors.Permission.Acting(ToolsRoles.CreateReport.name)
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => {
              setOpenDeleteDialog(true);
            }}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                toolsRoles || [],
                ToolsRoles.DeleteReport.value
              )
            }
            tooltipLabel={
              !isAbleToSeeUIElement(toolsRoles, ToolsRoles.DeleteReport.value)
                ? Messages.Errors.Permission.Acting(
                    ToolsRoles.DeleteReport.name
                  )
                : 'Delete'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.Reports],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="reportsGridStates"
            module={ModuleList.modules.reportCenter.name}
            section={ModuleList.modules.reportCenter.sections.reports}
          />
        </>
      }
    ></SharedToolbar>
  );
}
